import {
  getDescendantMenuPermissionButtons,
  indexMenuPermissions,
  isMenuPermissionButton,
  mergeMenuPermissionButtonsIntoChildren
} from '@/utils/menuPermission'

export default {
  data () {
    return {
      pendingMenuPermissionKeys: null
    }
  },
  computed: {
    menuPermissionIndex () {
      return indexMenuPermissions(this.menuPermissionTreeData || [])
    }
  },
  methods: {
    formatPermissionTree (menus) {
      return mergeMenuPermissionButtonsIntoChildren(menus || [])
    },
    filterMenuPermissionNode (visibleParents, data) {
      if (!isMenuPermissionButton(data)) return true
      const parent = this.menuPermissionIndex.parents[data.alias_name]
      return !!parent && visibleParents.includes(parent.alias_name)
    },
    refreshMenuPermissionTree () {
      this.$nextTick(() => {
        const tree = this.$refs.tree
        if (!tree) return
        const visibleParents = []
        Object.keys(this.menuPermissionIndex.nodes).forEach(alias => {
          const node = this.menuPermissionIndex.nodes[alias]
          if (!isMenuPermissionButton(node)) {
            const treeNode = tree.getNode(alias)
            if (treeNode && treeNode.checked) visibleParents.push(alias)
          }
        })
        tree.filter(visibleParents)
      })
    },
    handleMenuPermissionCheck (data) {
      const tree = this.$refs.tree
      if (!tree) return
      this.pendingMenuPermissionKeys = null
      if (isMenuPermissionButton(data)) {
        const parent = this.menuPermissionIndex.parents[data.alias_name]
        if (parent) tree.setChecked(parent.alias_name, true, false)
        return
      }
      const checkedMenus = Object.keys(this.menuPermissionIndex.nodes).filter(alias => {
        const item = this.menuPermissionIndex.nodes[alias]
        const itemNode = tree.getNode(alias)
        return !isMenuPermissionButton(item) && itemNode && itemNode.checked
      })
      const buttons = getDescendantMenuPermissionButtons(data)
      buttons.forEach(button => tree.setChecked(button.alias_name, false, false))
      checkedMenus.forEach(alias => tree.setChecked(alias, true, false))
      this.refreshMenuPermissionTree()
    },
    setMenuPermissionKeys (keys) {
      const permissionKeys = Array.from(new Set(keys || []))
      this.pendingMenuPermissionKeys = permissionKeys
      this.defaultCheckedKeys = permissionKeys
      this.$nextTick(() => {
        if (this.pendingMenuPermissionKeys !== permissionKeys) return
        const tree = this.$refs.tree
        if (!tree || !Object.keys(this.menuPermissionIndex.nodes).length) return
        const authorized = new Set(permissionKeys)
        tree.setCheckedKeys(permissionKeys)
        Object.keys(this.menuPermissionIndex.nodes).forEach(alias => {
          const node = this.menuPermissionIndex.nodes[alias]
          if (isMenuPermissionButton(node)) tree.setChecked(alias, false, false)
        })
        Object.keys(this.menuPermissionIndex.nodes).forEach(alias => {
          const node = this.menuPermissionIndex.nodes[alias]
          if (!isMenuPermissionButton(node) || !authorized.has(alias)) return
          const parent = this.menuPermissionIndex.parents[alias]
          if (parent && authorized.has(parent.alias_name)) {
            tree.setChecked(alias, true, false)
          }
        })
        Object.keys(this.menuPermissionIndex.nodes).forEach(alias => {
          const node = this.menuPermissionIndex.nodes[alias]
          if (!isMenuPermissionButton(node) && authorized.has(alias)) {
            tree.setChecked(alias, true, false)
          }
        })
        this.pendingMenuPermissionKeys = null
        this.refreshMenuPermissionTree()
      })
    },
    replayMenuPermissionKeys () {
      if (this.pendingMenuPermissionKeys !== null) {
        this.setMenuPermissionKeys(this.pendingMenuPermissionKeys)
      } else {
        this.refreshMenuPermissionTree()
      }
    },
    resetMenuPermissionTree () {
      this.pendingMenuPermissionKeys = null
      if (this.$refs.tree) this.$refs.tree.setCheckedKeys([])
      this.defaultCheckedKeys = []
      this.refreshMenuPermissionTree()
    },
    getMenuPermissionKeys () {
      const tree = this.$refs.tree
      if (!tree) return []
      const checkedKeys = []
      const buttonParentAliases = new Set()

      tree.getCheckedNodes().forEach(item => {
        if (isMenuPermissionButton(item)) {
          const parent = this.menuPermissionIndex.parents[item.alias_name]
          const parentNode = parent && tree.getNode(parent.alias_name)
          if (parentNode && parentNode.checked) {
            checkedKeys.push(item.alias_name)
            buttonParentAliases.add(parent.alias_name)
          }
        } else if (!item.isChildrenMenu) {
          checkedKeys.push(item.alias_name)
        }
      })
      buttonParentAliases.forEach(alias => {
        if (!checkedKeys.includes(alias)) checkedKeys.push(alias)
      })
      return checkedKeys
    }
  }
}
